import React, { useState } from "react";
import "./App.css";
import styles from "./styles/Dashboard.module.css";
import { Link } from "react-router-dom";
import { NavigationBarTestingMode } from "./components/navbar/NavigationBarTestingMode";
import { MainContentForwardTestingBot } from "./components/forward-testing-bot/MainContentForwardTestingBot";
import Sidebar from "./Sidebar";
import { useSidebar } from "./context/sidebarContext";

function ForwardTestingBot() {
  const { isOpen, toggleSidebar } = useSidebar();

  return (
    <div className={styles.dashboard}>
      <NavigationBarTestingMode />
      <Sidebar isOpen={isOpen} onClose={toggleSidebar} />
      <div className="  h-screen overflow-y-auto w-full">
        <div
          className={
            styles.mainContent +
            "h-screen overflow-y-auto flex flex-col items-start !gap-0 !pb-10 mx-auto max-w-6xl xl:!pt-[11vh]  p-5"
          }
        >
          {" "}
          <p className="text-sm font-semibold mt-6">
            <Link to="/testing-mode" className="text-[#0E0F11]">
              Which Tes...
            </Link>
            &nbsp;/{" "}
            <span className="text-[#0E0F11]/60">Forward Testing...</span>
          </p>
          <h1 className="text-2xl md:text-3xl font-bold m-0 mt-6 text-left">
            Forward Testing Bot
          </h1>
          <main className="w-full mt-6">
            <MainContentForwardTestingBot />
          </main>
        </div>
      </div>
    </div>
  );
}

export default ForwardTestingBot;
